import React from "react";
import '../../styles/style.css';
import HeaderFunctions from "../HeaderFunctions/HeaderFunctions";
import Header from "../Header/Header";

const Dashboard = ({ onLogout }) => {
  const { loading, handleLogout, } = HeaderFunctions();
  return (
    <>
  <Header loading={loading} handleLogout={handleLogout} />
    
  <div className="container">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item active" aria-current="page">
          </li>
        </ol>
      </nav>
    </div>
    <div className="container pb-4">
    </div>
    </>
  );
};

export default Dashboard;